export default {
  title: 'Edit company',
  backButton: 'All companies',
};
